import { useCallback, useState } from "react";
import { ResponseObject } from "../../common/common.entity";
import { ValidatefordecimalNumber, ValidationForDescription, alphaNumeric, alphabet, validStringWithNoSpace, validURLPath, validateBoolean, validateContactNumber, validateEmail, validateNewPassword, validationForNumber } from "../../common/inputValidation";
import { showNotification } from "../../redux/commonSlice";
import { useAppDispatch } from "../../store/hooks";
import { ErrorText, IFormBuilder, ValueTypes } from "./formBuilder.entity";

export const useDynamicForm = (
	initialFValues: any,
	validateOnChange = false,
	validate?: any,
	formFields?: IFormBuilder['formData']
) => {
	const [values, setValues] = useState<ResponseObject>(initialFValues);
	const [errors, setErrors] = useState<Record<string, string>>({});
	const dispatch = useAppDispatch()

	const handleInputChange = useCallback((e: any, newValue?: any, reason?: string) => {
		const { name, value } = e.target;
		newValue = newValue || value || null;
		if (newValue !== " ") {
			setValues((prevValues) => ({
				...prevValues,
				[name]: newValue,
			}));
			const field = formFields ? formFields?.filter(it => it ? (it.name === name) : null) : [];
			if (validateOnChange) formValidate({ [name]: newValue }, field);
		}
	}, [])
	const handleOptionChange = useCallback((e: any, option?: any, reason?: string) => {
		const { name, value } = option;

		setValues((prevValues) => ({
			...prevValues,
			[name]: value
		}));

		const field = formFields ? formFields?.filter(it => it ? (it.name === name) : null) : [];
		if (validateOnChange) formValidate({ [name]: (value || '') }, field);
	}, [])


	const handleInputSearchChanges = useCallback((e: any, { target }: any) => {
		const { name, value } = target;

		setValues((prevValues) => ({
			...prevValues,
			[name]: value,
		}));
	}, [])

	const handleSwitchChange = useCallback((e: any) => {
		const { name, checked } = e.target;
		setValues((prevValues) => ({
			...prevValues,
			[name]: checked,
		}));
	}, [])

	const handleServerSideErrors = useCallback((_data: any) => {
		if (_data) {
			const { code, error } = _data

			if (code === "PAYLOADVALERR") {
				error[0]?.map((_it: any) => {
					const { missingProperty } = _it?.params;
					const { message, keyword, instancePath } = _it

					const initial: any = initialFValues

					switch (keyword) {
						case "required":
							dispatch(
								showNotification({
									isOpen: true,
									message: message,
									type: "error",
								})
							);
							break
						case "errorMessage":
							let field: string = instancePath.replace(/\\|\//g, '')
							let abc = Object.keys?.(values)?.find((it: any) => it === field)
							if (abc) {
								setErrors((prevErrors) => ({
									...prevErrors,
									[field]: message
								}));
							} else {
								dispatch(
									showNotification({
										isOpen: true,
										message: `${field}: ${message}`,
										type: "error",
									})
								);
							}
							break
						case "type":
							let _field: any = instancePath.replace(/\\|\//g, '')
							setErrors((prevErrors: any) => ({
								...prevErrors,
								[_field]: message
							}));
							break
						default:
							console.log('unknown error type')
							break;
					}
				})
			} else {
				dispatch(
					showNotification({
						isOpen: true,
						message: _data?.message,
						type: "error",
					})
				);
			}
		}
	}, [])

	const resetForm = useCallback(() => {
		setValues(initialFValues);
		setErrors({});
	}, [])

	const getErrorText = useCallback((item: any, value: any) => {
		let temp: string = '';
		if (!(item.name in initialFValues)) return temp;
		if (item.required) {
			temp = ErrorText[item?.valueTypes] || ErrorText.invalid
			if (value === '' || value === null || value === undefined) temp = ErrorText.required;
			else switch (item?.valueTypes) {
				case ValueTypes.number:
					temp = !validationForNumber(value, item.maxLength || 100)
						? temp + (item.maxLength ? ` not more than ${item.maxLength} digits` : '')
						: ""
					break;
				case ValueTypes.noSpace:
					temp = !validStringWithNoSpace(value)
						? temp
						: "";
					break;
				case ValueTypes.onlyAlphabets:
					temp = !alphabet(value)
						? temp
						: "";
					break;
				case ValueTypes.allCharacter:
					temp = !ValidationForDescription(value)
						? temp
						: "";
					break;
				case ValueTypes.bothStringNumber:
					temp = !alphaNumeric(value)
						? temp
						: "";
					break;
				case ValueTypes.decimalNumber:
					temp = !ValidatefordecimalNumber(value)
						? temp
						: "";
					break;
				case ValueTypes.email:
					temp = !validateEmail(value)
						? temp
						: "";
					break;
				case ValueTypes.countryCode:
					temp = !validationForNumber(value)
						? temp
						: "";
					break;
				case ValueTypes.mobile:
					temp = !validateContactNumber(value, item.maxLength || 10)
						? temp + ` of ${item.maxLength || 10} digits`
						: "";
					break;
				case ValueTypes.checkbox:
					temp = !validateBoolean(value)
						? ErrorText.required
						: ""
					break;
				case ValueTypes.urlPath:
					temp = !validURLPath(value)
						? temp
						: ""
					break;
				case ValueTypes.password:
					temp = !validateNewPassword(value, item.maxLength)
						? temp
						: ""
					break;
				case ValueTypes.confirmPassword:
					temp = !validateNewPassword(value, item.maxLength)
						? temp
						: ""
					break;
				default:
					temp = '';
					break;
			}
		}
		return temp;
	}, [])

	const formValidate = useCallback(
		(
			data: ResponseObject,
			fields: Partial<IFormBuilder['formData']>
		) => {
			if (validate) return validate(data);

			let temp: Record<string, string> = {};
			let isError: boolean = false;

			fields?.forEach((_it) => {
				if (!_it) return;

				let errorMessage = getErrorText(_it, data[_it.name]);
				if (errorMessage) {
					isError = true;
					// log error
					console.log(_it.name, ":", data[_it.name], "|", errorMessage);
				}
				temp[_it.name] = errorMessage;
			});

			setErrors((prevErrors: Record<string, string>) => ({
				...prevErrors,
				...temp,
			}));

			// Check if any field has error return false else true.
			return !isError;
		}, [values])

	return {
		values,
		setValues,
		errors,
		setErrors,
		handleInputChange,
		resetForm,
		handleSwitchChange,
		handleInputSearchChanges,
		handleServerSideErrors,
		formValidate,
		getErrorText,
		handleOptionChange
	};
}

